import { makeStyles, tokens } from '@fluentui/react-components';

export const actionRelationshipInputStyles = makeStyles({
	dropdown: {
		minWidth: 'auto',
		borderBottom: 'none',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		'::after': {
			borderBottom: 'none'
		},
		':hover': {
			background: tokens.colorNeutralShadowAmbientLighter
		},
	},
	conditionTypeDropdown: {
		maxWidth: '240px'
	},
	dropdownWithError: {
		backgroundColor: tokens.colorPaletteRedBackground2,
		'& button': {
			color: tokens.colorPaletteRedBorder2,
		},
		'& svg': {
			color: tokens.colorPaletteRedBorder2,
		},
		':hover': {
			backgroundColor: tokens.colorPaletteRedBackground2,
		},
		':active': {
			background: tokens.colorNeutralBackground4Hover,
		}
	},
});